// extracted by mini-css-extract-plugin
module.exports = {"mergeModal":"mergeModal__Ot52D","text":"text__cKdCl","select":"select__PwYY8","list":"list__qFBfU","item":"item__iTyYZ","check":"check__3tqi9"};